import { Outlet } from "react-router-dom";

import { OrdersCreateProvider } from "./orders-create-context";

export const CollectChildOrderCreateLayoutPage = () => {
  return (
    <OrdersCreateProvider>
      <Outlet />
    </OrdersCreateProvider>
  );
};
